<template>
  <j-modal
    :confirmLoading="confirmLoading"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model :model="model" :rules="validatorRules" ref="form">
        <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="主键标识" prop="hzi">
          <a-input placeholder="请输入主键标识" v-model="model.hzi"></a-input>
        </a-form-model-item>-->
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类名称" prop="typeName">
          <a-input placeholder="请输入分类名称" v-model="model.typeName"></a-input>
        </a-form-model-item>
        <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备分类编码" prop="typeCode">
          <a-input placeholder="请输入设备分类编码" v-model="model.typeCode"></a-input>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型编码" prop="devClassCode">
          <a-input placeholder="请输入设备类型编码" v-model="model.devClassCode"></a-input>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="行业分类" prop="trade">
          <a-input placeholder="请输入行业分类" v-model="model.trade"></a-input>
        </a-form-model-item>-->
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="父级类型" prop="pid">
          <j-tree-select
            dict="`iwt-wf`.dev_class,type_name,id"
            hasChildField="has_child"
            pidField="pid"
            pidValue="-1"
            placeholder="请选择父级类型"
            ref="treeSelect"
            showSearch
            v-model="model.pid"
          ></j-tree-select>
        </a-form-model-item>
        <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="hasChild" prop="hasChild">
          <a-input placeholder="请输入hasChild" v-model="model.hasChild"></a-input>
        </a-form-model-item>-->
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序" prop="sortNo">
          <a-input placeholder="请输入序号" type="number" v-model="model.sortNo"></a-input>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备照片" prop="pictureObjId">
          <!-- <a-input placeholder="请输入设备照片(OSS服务对象ID)" v-model="model.pictureObjId"></a-input> -->
          <j-image-upload bizPath="scott/pic" v-model="model.pictureObjId"></j-image-upload>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  export default {
    name: "DevClassModal",
    components: {
    },

    data () {
      return {
        title: "操作",
        width: 800,
        visible: false,
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules: {
          typeName: [{ required: true, message: '请输入分类名称!' }],
        },
        url: {
          add: "/device/devClass/add",
          edit: "/device/devClass/edit",
        },
        expandedRowKeys: [],
        pidField: "pid",


      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add (obj) {
        this.modelDefault.pid = ''
        this.edit(Object.assign(this.modelDefault, obj));
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.clearValidate()
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            if (this.model.id && this.model.id === this.model[this.pidField]) {
              that.$message.warning("父级节点不能选择自己");
              that.confirmLoading = false;
              return;
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                this.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false
          }
        })
      },
      handleCancel () {
        this.close()
      },
      submitSuccess (formData, flag) {
        if (!formData.id) {
          let treeData = this.$refs.treeSelect.getCurrTreeData()
          this.expandedRowKeys = []
          this.getExpandKeysByPid(formData[this.pidField], treeData, treeData)
          this.$emit('ok', formData, this.expandedRowKeys.reverse());
        } else {
          this.$emit('ok', formData, flag);
        }
      },
      getExpandKeysByPid (pid, arr, all) {
        if (pid && arr && arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].key == pid) {
              this.expandedRowKeys.push(arr[i].key)
              this.getExpandKeysByPid(arr[i]['parentId'], all, all)
            } else {
              this.getExpandKeysByPid(pid, arr[i].children, all)
            }
          }
        }
      }


    }
  }
</script>